// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__e3wcl","savePackageButton":"ClientWallet_savePackageButton__1zIgi"};